import React from 'react';
import Icon from "../icon";
import './index.css';



const TipsAndTricks = (props) => {

    if (props.dir === "up") {
        return (
            <div className="tips-and-tricks up" id={props.id}>
                <button title="Close" className="btn-close float-right" onClick={props.onClose}><Icon name="times"/></button>
                <img src={`/img/arrow-${props.dir}.gif`} alt=""/>
                {props.children}
            </div>
        );
    } else if (props.dir === "down") {
        return (
            <div className="tips-and-tricks down" id={props.id}>
                <button title="Close" className="btn-close float-right" onClick={props.onClose}><Icon name="times"/></button>
                {props.children}
                <img src={`/img/arrow-${props.dir}.gif`} alt=""/>
            </div>
        );
    } else if (props.dir === "left") {
        return (
            <div className="tips-and-tricks left" id={props.id}>
                <button title="Close" className="btn-close float-right" onClick={props.onClose}><Icon name="times"/></button>
                {props.children}
                <img src={`/img/arrow-${props.dir}.gif`} alt=""/>
            </div>
        );
    } else if (props.dir === "right") {
        return (
            <div className="tips-and-tricks right" id={props.id}>
                <button title="Close" className="btn-close float-right" onClick={props.onClose}><Icon name="times"/></button>
                {props.children}
                <img src={`/img/arrow-${props.dir}.gif`} alt=""/>
            </div>
        );
    } else {
        return (
            <div className="tips-and-tricks" id={props.id}>
                <button title="Close" className="btn-close float-right" onClick={props.onClose}><Icon name="times"/></button>
                {props.children}
                <img src={'/img/arrow.gif'} alt=""/>
            </div>
        );
    }

};

export default TipsAndTricks;